
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateCustomCertificateForm from '@/services/SSL/forms/CreateCustomCertificateForm';
import { CertificateInterface, CertificatesRepositoryInterface } from '@/services/SSL/interfaces';
import { Component, Prop, Vue } from 'vue-property-decorator';
import WebsitePicker from '../website/WebsitePicker.vue';

@Component({
  inject: [
    'certificateRepository',
  ],
  components: {
    WebsitePicker,
  },
})
export default class CreateCustomCertificate extends Vue {
  @Prop({ required: false }) private readonly certificate!: CertificateInterface;

  public $refs!: { 'w-picker': HTMLFormElement };

  public readonly certificateRepository!: CertificatesRepositoryInterface;

  public form: WPXFormValue<CreateCustomCertificateForm> = new WPXFormValue(CreateCustomCertificateForm);

  public created(): void {
    if (!this.certificate) {
      return;
    }

    this.form.data.websiteId = this.certificate.websiteId;
  }

  public mounted(): void {
    if (!this.certificate) {
      return;
    }

    this.$refs['w-picker'].websiteSearch = this.certificate.domain;
  }

  public get formValid(): boolean {
    this.form.valid = true;
    return !this.form.valid;
  }

  public async createCertificate(): Promise<void> {
    try {
      await this.certificateRepository.registerCustomCertificate(
        this.form.data.websiteId,
        this.form.data.certificate,
        this.form.data.key,
        this.form.data.caBundle,
      );

      this.$successDialog.show('Custom Certificate Creation Started');
      await this.$router.push({ name: 'certificate_all' });
    } catch (err) {
      if (err instanceof Error) {
        console.error(err.message);
        this.$errorDialog.show([err.message]);
      } else {
        console.error(err);
      }
    }
  }
}
